module.exports = __webpack_public_path__ + "static/media/view5.008cfa81.jpg";